import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';

import { createPaymentRequestMutationDefinition } from '../utils/queryDefinitions';

export default function useCreatePaymentRequest() {
  const currentUser = useCurrentUser();

  const buyerProfileId = currentUser?.value?.data?.buyer_profile_id;

  const { mutateAsync: createPaymentRequest } = useResourceMutation(
    createPaymentRequestMutationDefinition(buyerProfileId)
  );

  return {
    createPaymentRequest
  };
}
